(function() {
    window.initWaiverForm = function() {
        var waiverContainer = document.getElementById('maeya-waiver');
        if (!waiverContainer) return;
        
        if (waiverContainer.dataset.initialized === "true") return;
        waiverContainer.dataset.initialized = "true";

        window.toggleCheck = function(id) {
            var cb = document.getElementById(id);
            if (cb) {
                cb.checked = !cb.checked;
                var checkWrap = cb.closest('.mw-check');
                if (checkWrap && cb.checked) checkWrap.classList.remove('mw-error-check');
            }
        };

        var canvas = document.getElementById('mw-canvas');
        if (!canvas) return;

        var ctx = canvas.getContext('2d');
        var drawing = false;
        var hasSigned = false;

        function mwResizeCanvas() {
            var dpr = window.devicePixelRatio || 1;
            var rect = canvas.parentElement.getBoundingClientRect();
            canvas.width = rect.width * dpr;
            canvas.height = 130 * dpr;
            ctx.scale(dpr, dpr);
            ctx.strokeStyle = '#1a1814';
            ctx.lineWidth = 1.8;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
        }
        mwResizeCanvas();
        window.addEventListener('resize', mwResizeCanvas);

        function mwGetPos(e) {
            var rect = canvas.getBoundingClientRect();
            var src = e.touches ? e.touches[0] : e;
            return { x: src.clientX - rect.left, y: src.clientY - rect.top };
        }

        // Hulpfunctie om rode handtekening-rand direct weg te halen zodra er getekend wordt
        function removeSigError() {
            hasSigned = true;
            document.getElementById('mw-sig-hint').style.opacity = '0';
            var sigWrap = document.getElementById('mw-sig-wrap');
            if (sigWrap) sigWrap.classList.remove('mw-error-sig');
        }

        // Canvas Events
        canvas.addEventListener('mousedown', function(e) { drawing = true; var p = mwGetPos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); });
        canvas.addEventListener('mousemove', function(e) {
            if (!drawing) return;
            var p = mwGetPos(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            removeSigError();
        });
        canvas.addEventListener('mouseup', function() { drawing = false; });
        canvas.addEventListener('mouseleave', function() { drawing = false; });

        canvas.addEventListener('touchstart', function(e) { e.preventDefault(); drawing = true; var p = mwGetPos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); }, { passive: false });
        canvas.addEventListener('touchmove', function(e) {
            e.preventDefault();
            if (!drawing) return;
            var p = mwGetPos(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            removeSigError();
        }, { passive: false });
        canvas.addEventListener('touchend', function() { drawing = false; });

        window.mwClearSig = function() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            hasSigned = false;
            document.getElementById('mw-sig-hint').style.opacity = '1';
        };

        function mwCollectGroup(group, otherId, otherTextId) {
            var labels = [];
            document.querySelectorAll('[data-group="' + group + '"]').forEach(function(cb) {
                if (!cb.checked) return;
                if (otherId && cb.id === otherId) {
                    var otherEl = document.getElementById(otherTextId);
                    var t = otherEl ? otherEl.value.trim() : '';
                    labels.push('Anders: ' + (t || '-'));
                } else {
                    var textEl = cb.parentElement.querySelector('.mw-check-text');
                    labels.push(textEl ? textEl.textContent.trim() : cb.id);
                }
            });
            return labels.join(', ');
        }

        window.mwGroupHasSelection = function(group) {
            var boxes = document.querySelectorAll('[data-group="' + group + '"]');
            for (var i = 0; i < boxes.length; i++) {
                if (boxes[i].checked) return true;
            }
            return false;
        };

        window.mwSubmit = async function() {
            var firstName = document.getElementById('mw-firstName').value.trim();
            var lastName = document.getElementById('mw-lastName').value.trim();
            var email = document.getElementById('mw-email').value.trim();
            var birthdate = document.getElementById('mw-birthdate').value;
            var phone = document.getElementById('mw-phone').value.trim();
            var piercingAnswered = window.mwGroupHasSelection('piercing');
            
            var c1 = document.getElementById('mw-c1').checked;
            var c2 = document.getElementById('mw-c2').checked;
            var c3 = document.getElementById('mw-c3').checked;
            var c4 = document.getElementById('mw-c4').checked;
            var errEl = document.getElementById('mw-error');

            function setFieldError(id, hasError, type = 'input') {
                var el = document.getElementById(id);
                if (!el) return;

                if (type === 'input') {
                    if (hasError) el.classList.add('mw-error-input');
                    else el.classList.remove('mw-error-input');
                } else if (type === 'check-wrapper') {
                    var wrapper = el.closest('.mw-check');
                    if (wrapper) {
                        if (hasError) wrapper.classList.add('mw-error-check');
                        else wrapper.classList.remove('mw-error-check');
                    }
                }
            }

            var condEl = document.getElementById('mw-cond-1');
            var medEl = document.getElementById('mw-med-yes');
            var hasMedicalSection = !!(condEl && medEl);

            var conditionsAnswered = hasMedicalSection ? window.mwGroupHasSelection('cond') : true;
            var medicationAnswered = hasMedicalSection
                ? (document.getElementById('mw-med-yes').checked || document.getElementById('mw-med-no').checked)
                : true;
            var allergiesAnswered = hasMedicalSection ? window.mwGroupHasSelection('alg') : true;

            var errFirstName = !firstName;
            var errLastName = !lastName;
            var errEmail = !email;
            var errBirthdate = !birthdate;
            var errPiercing = !piercingAnswered;
            
            var errC1 = !c1;
            var errC2 = !c2;
            var errC3 = !c3;
            var errSig = !hasSigned;

            setFieldError('mw-firstName', errFirstName, 'input');
            setFieldError('mw-lastName', errLastName, 'input');
            setFieldError('mw-email', errEmail, 'input');
            setFieldError('mw-birthdate', errBirthdate, 'input');
            var piercingBlock = document.querySelector('[data-group="piercing"]').closest('.mw-field');
            if (piercingBlock) {
                if (errPiercing) piercingBlock.classList.add('mw-error-block');
                else piercingBlock.classList.remove('mw-error-block');
            }

            setFieldError('mw-c1', errC1, 'check-wrapper');
            setFieldError('mw-c2', errC2, 'check-wrapper');
            setFieldError('mw-c3', errC3, 'check-wrapper');

            // Handtekening kader rood maken indien niet getekend
            var sigWrap = document.getElementById('mw-sig-wrap');
            if (sigWrap) {
                if (errSig) sigWrap.classList.add('mw-error-sig');
                else sigWrap.classList.remove('mw-error-sig');
            }

            if (hasMedicalSection) {
                var condBlock = condEl.closest('.mw-med-block');
                var medBlock = medEl.closest('.mw-med-block');
                var algBlock = document.getElementById('mw-alg-1').closest('.mw-med-block');

                if (condBlock) {
                    if (!conditionsAnswered) condBlock.classList.add('mw-error-block');
                    else condBlock.classList.remove('mw-error-block');
                }
                if (medBlock) {
                    if (!medicationAnswered) medBlock.classList.add('mw-error-block');
                    else medBlock.classList.remove('mw-error-block');
                }
                if (algBlock) {
                    if (!allergiesAnswered) algBlock.classList.add('mw-error-block');
                    else algBlock.classList.remove('mw-error-block');
                }
            }

            if (errFirstName || errLastName || errEmail || errBirthdate || errPiercing || errC1 || errC2 || errC3 || errSig
                || !conditionsAnswered || !medicationAnswered || !allergiesAnswered ) {
                
                errEl.textContent = window.error || 'Vul alle verplichte velden (*) in en zet je handtekening.';
                errEl.style.display = 'block';
                errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }

            errEl.style.display = 'none';
            var sending = window.sending || "Bezig met verzenden";
            var btn = document.getElementById('mw-submit');
            btn.disabled = true;
            btn.textContent = sending + '…';

            var timestamp = new Date().toLocaleString('nl-NL', { timeZone: 'Europe/Amsterdam' });
            var signatureData = canvas.toDataURL('image/png');

            var emailHeader = window.emailHeader || 'Kopie van je toestemmingsformulier - Maeya Jewelry';
            var emailBody = window.emailBody || 'Bedankt voor het invullen! Hier is een kopie van je ingevulde formulier voor je eigen administratie. Wij hebben er zin in!';
            var emailConsentForm = window.emailConsentForm || '';
            var emailName = window.emailName || '';
            var emailEmail = window.emailEmail || '';
            var emailPhone = window.emailPhone || '';
            var emailBirthdate = window.emailBirthdate || '';
            var emailTime = window.emailTime || '';

            var medicalConditions = hasMedicalSection ? mwCollectGroup('cond', 'mw-cond-other', 'mw-cond-other-text') : '';
            var medicationUse = hasMedicalSection
                ? (document.getElementById('mw-med-yes').checked
                    ? 'Ja: ' + (document.getElementById('mw-med-yes-text').value.trim() || '-')
                    : 'Nee')
                : '';
            var allergies = hasMedicalSection ? mwCollectGroup('alg', 'mw-alg-other', 'mw-alg-other-text') : '';

            try {
                await fetch('https://script.google.com/macros/s/AKfycby_vRS-9l2Ld9ss2U6NIdLDcSXmRDtM0feFzHWvEDxEM_168YySuZNZgpwzwuAwJrsljA/exec', {
                    method: 'POST',
                    mode: 'no-cors',
                    body: JSON.stringify({
                        first_name: firstName, 
                        last_name: lastName, 
                        name: firstName + ' ' + lastName, 
                        email: email,
                        phone: phone || '', 
                        birthdate: birthdate, 
                        piercing_type: mwCollectGroup('piercing'),
                        agreement_terms: 'Ja', 
                        agreement_age: 'Ja', 
                        agreement_health: 'Ja',
                        permission_photo: c4 ? 'Ja' : 'Nee', 
                        medical_conditions: medicalConditions,
                        medication_use: medicationUse,
                        allergies: allergies,
                        timestamp: timestamp, 
                        signature: signatureData,
                        email_header: emailHeader,
                        email_body: emailBody,
                        email_consent_form: emailConsentForm,
                        email_name: emailName,
                        email_email: emailEmail,
                        email_phone: emailPhone,
                        email_birthdate: emailBirthdate,
                        email_time: emailTime,
                    })
                });
            } catch(e) { console.log('Webhook error:', e); }

            document.getElementById('maeya-form').style.display = 'none';
            document.getElementById('mw-title').style.display = 'none';
            document.getElementById('mw-sname').textContent = firstName;
            var s = document.getElementById('maeya-success');
            s.style.display = 'block';
            s.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        if (typeof flatpickr !== 'undefined') {
            flatpickr("#mw-birthdate", {
                dateFormat: "d-m-Y",
                allowInput: false,
                maxDate: "today",
                locale: typeof flatpickr.l10ns !== 'undefined' ? flatpickr.l10ns.nl : undefined
            });
        }
    };

    document.addEventListener('DOMContentLoaded', window.initWaiverForm);
    document.addEventListener('shopify:section:load', window.initWaiverForm);
})();